import actionDataProvider from './actions';
import assessmentsDataProvider from './assessments';
import attendanceDataProvider from './attendance';
import attendanceB2bDataProvider from './attendance_b2b';
import changeDataProvider from './changes';
import cohortDataProvider from './cohorts';
import cohortB2bDataProvider from './cohorts_b2b';
import cohortSettingsDataProvider from './cohort_settings';
import dataDataProvider from './data';
import dropDataProvider from './drop';
import deliveryDataProvider from './deliveries';
import emailDataProvider from './emails';
import groupDataProvider from './groups';
import labsDataProvider from './labs';
import metricDataProvider from './metrics';
import moveDataProvider from './move';
import oneOnOneDataProvider from './one_on_ones';
import projectOutcomesProvider from './project_outcomes';
import quizzesDataProvider from './quizzes';
import surveyCommentsProvider from './survey_comments';
import sessionDataProvider from './sessions';
import studentDataProvider from './students';
import studentClusterDataProvider from './student_clusters';
import tryHackMeLabsDataProvider from './tryhackme_labs';
import userDataProvider from './users';
import zoomAttendanceProvider from './zoom_attendance';
import zoomRecordingsProvider from './zoom_recordings';
import zoomSessionsProvider from './zoom_sessions';

export default {
  actions: actionDataProvider,
  assessments: assessmentsDataProvider,
  attendance: attendanceDataProvider,
  attendance_b2b: attendanceB2bDataProvider,
  changes: changeDataProvider,
  cohorts: cohortDataProvider,
  cohorts_b2b: cohortB2bDataProvider,
  cohort_settings: cohortSettingsDataProvider,
  data: dataDataProvider,
  deliveries: deliveryDataProvider,
  emails: emailDataProvider,
  drop: dropDataProvider,
  groups: groupDataProvider,
  labs: labsDataProvider,
  metrics: metricDataProvider,
  move: moveDataProvider,
  one_on_ones: oneOnOneDataProvider,
  project_outcomes: projectOutcomesProvider,
  quizzes: quizzesDataProvider,
  survey_comments: surveyCommentsProvider,
  sessions: sessionDataProvider,
  student_clusters: studentClusterDataProvider,
  students: studentDataProvider,
  tryhackme_labs: tryHackMeLabsDataProvider,
  users: userDataProvider,
  zoom_attendance: zoomAttendanceProvider,
  zoom_recordings: zoomRecordingsProvider,
  zoom_sessions: zoomSessionsProvider,
};
